// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export type ThirdPartyOrganizationMetadata = ThirdPartyOrganizationJwtMetadata | ThirdPartyOrganizationSamlMetadata;

export interface ThirdPartyOrganizationJwtMetadata {
  opaqueIdField: string;
  nameField: string;
  emailField: string;
  secretKeys: Array<string>;
}

export type SamlSigningAlgorithm = 'SHA1_RSA' | 'SHA256_RSA';

export interface ThirdPartyOrganizationSamlMetadata {
  nameAttribute?: string | null;
  firstNameAttribute?: string | null;
  lastNameAttribute?: string | null;
  emailAttribute: string;
  opaqueIdAttribute: string;
  externalIdAttribute?: string | null;
  signSamlRequest: boolean;
  allowsIdpInitiatedLogin: boolean;
  signingAlgorithm: SamlSigningAlgorithm;
  refreshUrl?: string | null;
  signingCertificateFingerprint?: string | null;
}

export type SsoLoginMethod = 'JWT' | 'SAML' | 'JWT_INVITE' | 'LTI';

export interface ThirdPartyOrganizationAddress {
  line1: string;
  line2?: string | null;
  city: string;
  state: string;
  zipCode: string;
  country: string;
}

export type ProgramVisibilityRule = 'EVERYONE' | 'ACCEPTED_PRIVACY_NOTICE';

export type OrganizationType = 'BUSINESS' | 'CAMPUS' | 'GOVERNMENT';

export interface ThirdPartyOrganizationsV1 {
  id: string;
  name: string;
  slug: string;
  metadata?: ThirdPartyOrganizationMetadata | null;
  loginMethod?: SsoLoginMethod | null;
  partnerId?: number | null;
  isReal: boolean;
  address?: ThirdPartyOrganizationAddress | null;
  taxId?: string | null;
  programVisibilityRule: ProgramVisibilityRule;
  entityId?: string | null;
  emailDomain?: string | null;
  primaryColor?: string | null;
  iconColor?: string | null;
  landingPageBanner?: string | null;
  squareLogo?: string | null;
  rectangularLogo?: string | null;
  supportsDegreeSSOLogin: boolean;
  lastUpdatedAt?: number | null;
  organizationType?: OrganizationType | null;
  organizationEmployeeRange?: string | null;
  __all: string;
}

export interface ThirdPartyOrganization {
  name: string;
  slug: string;
  metadata?: ThirdPartyOrganizationMetadata | null;
  loginMethod?: SsoLoginMethod | null;
  partnerId?: number | null;
  isReal: boolean;
  address?: ThirdPartyOrganizationAddress | null;
  taxId?: string | null;
  programVisibilityRule: ProgramVisibilityRule;
  entityId?: string | null;
  emailDomain?: string | null;
  primaryColor?: string | null;
  iconColor?: string | null;
  landingPageBanner?: string | null;
  squareLogo?: string | null;
  rectangularLogo?: string | null;
  supportsDegreeSSOLogin: boolean;
  lastUpdatedAt?: number | null;
  organizationType?: OrganizationType | null;
  organizationEmployeeRange?: string | null;
  __all: string;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface ThirdPartyOrganizationsV1Connection {
  elements: Array<ThirdPartyOrganizationsV1> | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface ThirdPartyOrganizationsV1ByEntityIdQuery {
  ThirdPartyOrganizationsV1: {
    byEntityId: ThirdPartyOrganizationsV1Connection | null;
  } | null;
}

export interface ThirdPartyOrganizationsV1ByEntityIdQueryVariables {
  entityId: string;
  includes?: string | null;
}

export interface ThirdPartyOrganizationsV1ByFullTextSearchQuery {
  ThirdPartyOrganizationsV1: {
    byFullTextSearch: ThirdPartyOrganizationsV1Connection | null;
  } | null;
}

export interface ThirdPartyOrganizationsV1ByFullTextSearchQueryVariables {
  queryString: string;
  includes?: string | null;
}

export interface ThirdPartyOrganizationsV1ByLoginMethodQuery {
  ThirdPartyOrganizationsV1: {
    byLoginMethod: ThirdPartyOrganizationsV1Connection | null;
  } | null;
}

export interface ThirdPartyOrganizationsV1ByLoginMethodQueryVariables {
  loginMethod: string;
  includes?: string | null;
}

export interface ThirdPartyOrganizationsV1BySlugQuery {
  ThirdPartyOrganizationsV1: {
    bySlug: ThirdPartyOrganizationsV1Connection | null;
  } | null;
}

export interface ThirdPartyOrganizationsV1BySlugQueryVariables {
  slug: string;
  includes?: string | null;
}

export interface ThirdPartyOrganizationsV1GetQuery {
  ThirdPartyOrganizationsV1: {
    get: ThirdPartyOrganizationsV1Connection | null;
  } | null;
}

export interface ThirdPartyOrganizationsV1GetQueryVariables {
  id: string;
  includes?: string | null;
}

export interface ThirdPartyOrganizationsV1GetAllQuery {
  ThirdPartyOrganizationsV1: {
    getAll: ThirdPartyOrganizationsV1Connection | null;
  } | null;
}

export interface ThirdPartyOrganizationsV1GetAllQueryVariables {
  includes?: string | null;
}

export interface ThirdPartyOrganizationsV1MultiGetQuery {
  ThirdPartyOrganizationsV1: {
    multiGet: ThirdPartyOrganizationsV1Connection | null;
  } | null;
}

export interface ThirdPartyOrganizationsV1MultiGetQueryVariables {
  ids: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-link mutations
// ========================================================================

export interface ThirdPartyOrganizationsV1CreateMutation {
  ThirdPartyOrganizationsV1: {
    create: ThirdPartyOrganizationsV1Connection | null;
  } | null;
}

export interface ThirdPartyOrganizationsV1CreateMutationVariables {
  includes?: string | null;
}

export interface ThirdPartyOrganizationsV1GetMetadataDownloadUrlMutation {
  ThirdPartyOrganizationsV1: {
    getMetadataDownloadUrl: ThirdPartyOrganizationsV1Connection | null;
  } | null;
}

export interface ThirdPartyOrganizationsV1GetMetadataDownloadUrlMutationVariables {
  id: string;
  includes?: string | null;
}

export interface ThirdPartyOrganizationsV1GetMetadataExpiryMutation {
  ThirdPartyOrganizationsV1: {
    getMetadataExpiry: ThirdPartyOrganizationsV1Connection | null;
  } | null;
}

export interface ThirdPartyOrganizationsV1GetMetadataExpiryMutationVariables {
  id: string;
  refreshDays: string;
  warningDays: string;
  includes?: string | null;
}

export interface ThirdPartyOrganizationsV1GetMetadataUploadUrlMutation {
  ThirdPartyOrganizationsV1: {
    getMetadataUploadUrl: ThirdPartyOrganizationsV1Connection | null;
  } | null;
}

export interface ThirdPartyOrganizationsV1GetMetadataUploadUrlMutationVariables {
  id: string;
  includes?: string | null;
}

export interface ThirdPartyOrganizationsV1GetSigningCertificatesMutation {
  ThirdPartyOrganizationsV1: {
    getSigningCertificates: ThirdPartyOrganizationsV1Connection | null;
  } | null;
}

export interface ThirdPartyOrganizationsV1GetSigningCertificatesMutationVariables {
  id: string;
  includes?: string | null;
}

export interface ThirdPartyOrganizationsV1InitiateLoginFlowMutation {
  ThirdPartyOrganizationsV1: {
    initiateLoginFlow: ThirdPartyOrganizationsV1Connection | null;
  } | null;
}

export interface ThirdPartyOrganizationsV1InitiateLoginFlowMutationVariables {
  id: string;
  returnTo?: string | null;
  format?: string | null;
  includes?: string | null;
}

export interface ThirdPartyOrganizationsV1PatchMutation {
  ThirdPartyOrganizationsV1: {
    patch: ThirdPartyOrganizationsV1Connection | null;
  } | null;
}

export interface ThirdPartyOrganizationsV1PatchMutationVariables {
  id: string;
  includes?: string | null;
}

export interface ThirdPartyOrganizationsV1SetIsRealMutation {
  ThirdPartyOrganizationsV1: {
    setIsReal: ThirdPartyOrganizationsV1Connection | null;
  } | null;
}

export interface ThirdPartyOrganizationsV1SetIsRealMutationVariables {
  id: string;
  isReal: string;
  includes?: string | null;
}

export interface ThirdPartyOrganizationsV1SetOrganizationEmployeeRangeMutation {
  ThirdPartyOrganizationsV1: {
    setOrganizationEmployeeRange: ThirdPartyOrganizationsV1Connection | null;
  } | null;
}

export interface ThirdPartyOrganizationsV1SetOrganizationEmployeeRangeMutationVariables {
  id: string;
  organizationEmployeeRange: string;
  includes?: string | null;
}

export interface ThirdPartyOrganizationsV1SetOrganizationTypeMutation {
  ThirdPartyOrganizationsV1: {
    setOrganizationType: ThirdPartyOrganizationsV1Connection | null;
  } | null;
}

export interface ThirdPartyOrganizationsV1SetOrganizationTypeMutationVariables {
  id: string;
  organizationType: string;
  includes?: string | null;
}

export interface ThirdPartyOrganizationsV1UpdateMutation {
  ThirdPartyOrganizationsV1: {
    update: ThirdPartyOrganizationsV1Connection | null;
  } | null;
}

export interface ThirdPartyOrganizationsV1UpdateMutationVariables {
  id: string;
  input: ThirdPartyOrganization;
  includes?: string | null;
}

export interface ThirdPartyOrganizationsV1UpdateEntityIdMutation {
  ThirdPartyOrganizationsV1: {
    updateEntityId: ThirdPartyOrganizationsV1Connection | null;
  } | null;
}

export interface ThirdPartyOrganizationsV1UpdateEntityIdMutationVariables {
  id: string;
  entityId: string;
  includes?: string | null;
}

export interface ThirdPartyOrganizationsV1UpdateMetadataMutation {
  ThirdPartyOrganizationsV1: {
    updateMetadata: ThirdPartyOrganizationsV1Connection | null;
  } | null;
}

export interface ThirdPartyOrganizationsV1UpdateMetadataMutationVariables {
  id: string;
  includes?: string | null;
}

export interface ThirdPartyOrganizationsV1UpdateSigningCertificateMutation {
  ThirdPartyOrganizationsV1: {
    updateSigningCertificate: ThirdPartyOrganizationsV1Connection | null;
  } | null;
}

export interface ThirdPartyOrganizationsV1UpdateSigningCertificateMutationVariables {
  id: string;
  signingCertificateFingerprint: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
    ? PartialConstruction<T[TKey]>
    : T[TKey];
};

export class ThirdPartyOrganizationsV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'thirdPartyOrganizations.v1' as const;

  declare id: string;

  declare name: string;

  declare slug: string;

  declare metadata?: ThirdPartyOrganizationMetadata | null;

  declare loginMethod?: SsoLoginMethod | null;

  declare partnerId?: number | null;

  declare isReal: boolean;

  declare address?: ThirdPartyOrganizationAddress | null;

  declare taxId?: string | null;

  declare programVisibilityRule: ProgramVisibilityRule;

  declare entityId?: string | null;

  declare emailDomain?: string | null;

  declare primaryColor?: string | null;

  declare iconColor?: string | null;

  declare landingPageBanner?: string | null;

  declare squareLogo?: string | null;

  declare rectangularLogo?: string | null;

  declare supportsDegreeSSOLogin: boolean;

  declare lastUpdatedAt?: number | null;

  declare organizationType?: OrganizationType | null;

  declare organizationEmployeeRange?: string | null;

  declare __all: string;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<ThirdPartyOrganizationsV1>) {
    super(params);
  }
}
